module.exports = __webpack_public_path__ + "img/kh.72c948be.svg";